import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import { Col, Button, Row, Space } from "antd";
import { DatePicker, Input, Select, TimePicker } from "components/form";

import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/redeemTimeSchema";
import { useEffect, useState } from "react";
import { getBase64 } from "components/elements/upload/Upload.utils";
import { dataURLtoFile } from "utils/helper";
import * as service from "../../company/services/companyApi";
import { CloudUploadOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";

function formatDate(dateString, pattern = "DD-MM-YYYY") {
  if (!dateString) return;
  const date = dayjs(dateString, pattern);
  return date.format("DD-MM-YYYY");
}


function RedeemTimeForm({
  className = "",
  modalType = 'view',
  initialValues = {},
  onDraft = () => { },
  onCancel = () => { },
  onSubmit = () => { },
  collectTimeOptions = []
}) {


  const [fileSizeInMB, setfileSizeInMB] = useState(0)
  const [fileName, seeFileName] = useState('');
  const [imageUrl, setImageUrl] = useState();

  function base64ToFile(base64String, fileName, mimeType = 'application/octet-stream') {
    const byteCharacters = atob(base64String);
    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: mimeType });
    return new File([blob], fileName, { type: mimeType });
  }




  useEffect(() => {
    if (initialValues?.attachFile && initialValues?.attachFile[0]) {
      const { fileByte, fileName, fileType } = initialValues.attachFile[0];

      if (typeof fileByte === "string") {
        const blob = new Blob([Uint8Array.from(atob(fileByte), c => c.charCodeAt(0))], {
          type: fileType,
        });
        const fileUrl = URL.createObjectURL(blob);
        setImageUrl(fileUrl);
        seeFileName(fileName);
        const fileSizeInMB = (blob.size / (1024 * 1024)).toFixed(2);
        setfileSizeInMB(fileSizeInMB);

      }
    } else {
      setImageUrl(null);
    }
  }, [initialValues?.attachFile]);



  const { t } = useTranslation();
  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...INITIAL_VALUES,
        ...initialValues,
        collectTimeId: initialValues?.collectTimeRequestId ? initialValues?.collectTimeRequestId : null,
        redeemDate: initialValues?.redeemDate ? dayjs(initialValues?.redeemDate) : null
      }}
      onSubmit={onSubmit}
      validationSchema={schema}
    >
      {({ values = {}, resetForm = () => { }, setFieldValue }) => {

        const selectedOption = collectTimeOptions.find(
          (option) => option.id === values.workTypeId
        );

        const onAttachFileChange = async (attachFile) => {
          try {
            const allowedTypes = ["image/png", "image/jpeg", "application/pdf", "application/vnd.ms-excel"];
            const fileType = attachFile?.file?.type;
            const fileSize = attachFile?.file?.size;

            // ตรวจสอบประเภทไฟล์
            if (!allowedTypes.includes(fileType)) {
              throw new Error("Unsupported file type. Only PNG, JPEG, XLS, and PDF are allowed.");
            }

            // const maxSize = 1 * 1024 * 1024;
            // if (fileSize > maxSize) {
            //   throw new Error("File size exceeds the 1 MB limit.");
            // }

            if (fileType === "application/pdf" || fileType === "application/vnd.ms-excel") {
              getBase64(attachFile?.file?.originFileObj, (url) => {
                const filename = `${Date.now()}_${attachFile?.file?.name}`;
                const file = dataURLtoFile(url, filename);
                seeFileName(filename)
                setFieldValue("attachFile", file);
                setImageUrl(url);
              });
            } else {
              const compressImg = await service.compressedImage({
                file: attachFile?.file?.originFileObj,
              });

              getBase64(compressImg?.data, (url) => {
                const filename = `${Date.now()}_${attachFile?.file?.name}`;
                const file = dataURLtoFile(url, filename);
                seeFileName(filename)
                setFieldValue("attachFile", file);
                setImageUrl(url);
              });
            }
          } catch (error) {
            alert(error.message);
          }
        };
        return (
          <Form className={className}>
            {/* <Divider /> */}
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
              <Row gutter={[0, 12]} style={{ marginLeft: "0px" }}>
                <Col span={24}>
                  <DatePicker
                    disabled={modalType == 'view'}
                    name="redeemDate"
                    label={t('my_request.label.date')}
                    placeholder={t('common.placeholder.ddmmyyyy')}
                    size="large"
                    format={formatDate()}
                    required
                  />
                </Col>
                <Col span={12} style={{ paddingRight: "8px" }}>
                  <TimePicker
                    disabled={modalType == 'view'}
                    name="startTime"
                    label={t('leave_type.label.start-time')}
                    suffeicon={false}
                    format="HH:mm:ss"
                    size="large"
                  />
                </Col>
                <Col span={12} style={{ paddingLeft: "8px" }}>
                  <TimePicker
                    disabled={modalType == 'view'}
                    name="endTime"
                    label={t('leave_type.label.end-time')}
                    suffeicon={false}
                    format="HH:mm:ss"
                    size="large"
                  />
                </Col>
                <Col span={24}>
                  <Select
                    disabled={modalType == 'view'}
                    name="collectTimeId"
                    label={t('my_request.label.available-time-to-exchange')}
                    placeholder={t('common.pleaseSelect')}
                    size="large"
                    options={collectTimeOptions}
                    required
                  />
                </Col>
                <Col span={24}>
                  <Input
                    disabled={modalType == 'view'}
                    name="description"
                    label={t('expense.lable.reason')}
                    placeholder={t('expense.lable.pls_fill_reason')}
                    size="large"
                    required
                  />
                </Col>
                {/*   */}
                {selectedOption?.attachment === 'Y' && !imageUrl ? (
                  <><Dragger
                    disabled={modalType == 'view'}
                    name="attachFile"
                    multiple={false}
                    onChange={(e) => {
                      if (e.event) {
                        onAttachFileChange(e);
                      }
                    }}
                    style={{
                      border: "1px solid #EAECF0",
                      borderRadius: "10px",
                      background: "#FAFAFA",
                      padding: "20px",
                    }}
                  >
                    <p className="ant-upload-drag-icon">
                      <CloudUploadOutlined style={{ fontSize: "32px", color: "#888" }} />
                    </p>
                    <p className="ant-upload-text" style={{ fontSize: "16px", fontWeight: "500", color: "#4A4A4A" }}>
                      เลือกไฟล์ที่ต้องการ หรือ ลากและวาง
                    </p>

                  </Dragger>
                    <p>รองรับไฟล์: PNG, JPEG, PDF ขนาดไม่เกิน 1 mb</p></>
                ) :
                  imageUrl ? (
                    <div
                      style={{
                        border: "1px solid #EAECF0",
                        borderRadius: "10px",
                        padding: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "500px",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      }}
                    >
                      <a
                        href={imageUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          textDecoration: "none",
                        }}
                      >
                        <img
                          src={imageUrl}
                          alt="uploaded"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = "none";
                            const fallbackElement = e.target.nextElementSibling;
                            if (fallbackElement) fallbackElement.style.display = "block";
                          }}
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                            borderRadius: "5px",
                            marginRight: "10px",
                          }}
                        />
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: "bold", color: "#333" }}>{fileName}</div>
                          <div style={{ fontSize: "12px", color: "#888" }}>{fileSizeInMB} MB</div>
                        </div>
                      </a>
                      <Button
                        type="default"
                        style={{
                          background: "none",
                          border: "none",
                          color: "#888",
                          cursor: "pointer",
                          fontSize: "18px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => {
                          setImageUrl(null);
                          setFieldValue("attachFile", null);
                        }}
                      >
                        &#x2715;
                      </Button>
                    </div>
                  ) : null
                }
              </Row>
              <Row justify="end">
                <Space direction="horizontal" size={12}>
                  <Button
                    id="mst__cancelBtn"
                    type="default"
                    onClick={() => {
                      resetForm();
                      onCancel();
                    }}
                    style={{ height: "40px", borderRadius: "8px" }}
                  >
                    {t("common.cancel")}
                  </Button>
                  {modalType == 'view' ? null :
                    <><Button
                      id="mst__cancelBtn"
                      type="default"
                      onClick={() => onDraft(values)}
                      style={{ height: "40px", borderRadius: "8px" }}
                    >
                      {t("common.draft")}
                    </Button><Button htmlType="submit" type="primary"
                      onClick={() => {
                        if (values?.attachFile && values?.attachFile[0]?.fileByte) {
                          const File = base64ToFile(values?.attachFile[0]?.fileByte, values?.attachFile[0]?.fileName, values?.attachFile[0]?.fileType);
                          setFieldValue("attachFile", File);
                        }
                      }}
                      style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", color: "white", boxShadow: "none" }}>
                        {t("my_timesheet.label.approve")}
                      </Button></>
                  }
                </Space>
              </Row>
            </Space>
          </Form>
        );
      }}
    </Formik>
  );
}

export default RedeemTimeForm;
